import styled from "styled-components";
import { themevals as theme } from "theme/themevals";

export const PillWrapper = styled.div`
    display:flex;
    flex-direction:column;
    gap:8px;
`
export const InviteWrapper = styled.div`
    display:flex;
    flex-direction:row;
    cursor:pointer;
`

